import React, { useEffect, useState } from "react";
import {
    getCronTasks,
    toggleCronTask,
    runCronNow,
} from "../services/cronService";
import { fetchCronTemplates } from "../services/cronTemplateService";

import CronStatusBadge from "../components/cron/CronStatusBadge";
import { toast } from "react-toastify";
import CronToggleSwitch from "../components/cron/CronToggleSwitch";
import RunCronModal from "../components/cron/RunCronModal";

const CronManager = () => {
    const [tasks, setTasks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [actionLoading, setActionLoading] = useState(null);

    const [runModalOpen, setRunModalOpen] = useState(false);
    const [selectedTask, setSelectedTask] = useState(null);

    const [templates, setTemplates] = useState([]);

    const fetchTasks = async () => {
        try {
            setLoading(true);
            const res = await getCronTasks();
            setTasks(res.data);
        } catch (error) {
            toast.error("Failed to load cron tasks");
        } finally {
            setLoading(false);
        }
    };

    const runWithWeek = async (weekNumber) => {

        try {

            setActionLoading(selectedTask);

            await runCronNow(selectedTask, weekNumber);

            toast.success("Task triggered successfully");

            setRunModalOpen(false);

            setTasks(prev =>
                prev.map(task =>
                    task.id === selectedTask
                        ? { ...task, is_running: true }
                        : task
                )
            );

        } catch {

            toast.error("Failed to trigger task");

        } finally {

            setActionLoading(null);

        }

    };

    useEffect(() => {
        fetchTasks();
    }, []);

    useEffect(() => {
        const runningTaskExists = tasks.some(task => task.is_running);

        if (!runningTaskExists) return;

        const interval = setInterval(() => {
            fetchTasks();
        }, 4000);

        return () => clearInterval(interval);
    }, [tasks]);

    const handleToggle = async (id) => {
        try {
            setActionLoading(id);
            await toggleCronTask(id);
            toast.success("Task status updated");
            fetchTasks();
        } catch {
            toast.error("Failed to update task");
        } finally {
            setActionLoading(null);
        }
    };
    const handleRunNow = async (id) => {
        try {
            setActionLoading(id);

            await runCronNow(id);

            toast.success("Task triggered successfully");

            // Immediately mark this task as running in UI
            setTasks(prev =>
                prev.map(task =>
                    task.id === id
                        ? { ...task, is_running: true }
                        : task
                )
            );

        } catch {
            toast.error("Failed to trigger task");
        } finally {
            setActionLoading(null);
        }
    };

    const openRunModal = async (task) => {

        try {

            const res = await fetchCronTemplates(task.name);

            const data = res.data.results || res.data;

            setTemplates(data);

            setSelectedTask(task.id);

            setRunModalOpen(true);

        } catch {

            toast.error("Failed to load templates");

        }

    };
    // const handleRunNow = async (id) => {
    //     try {
    //         setActionLoading(id);
    //         await runCronNow(id);
    //         toast.success("Task triggered successfully");
    //         fetchTasks();
    //     } catch {
    //         toast.error("Failed to trigger task");
    //     } finally {
    //         setActionLoading(null);
    //     }
    // };

    if (loading) {
        return (
            <div className="p-6 text-gray-600">Loading Cron Tasks...</div>
        );
    }

    return (
        <div className="p-6">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
                <h2 className="text-2xl font-semibold mb-6">
                    Cron Manager
                </h2>

                {tasks.length === 0 ? (
                    <div className="text-center py-16 text-gray-500">
                        <p className="text-lg font-medium">
                            No Scheduled Tasks Found
                        </p>
                        <p className="text-sm mt-2">
                            Add entries in ScheduledTask table to manage cron jobs.
                        </p>
                    </div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="min-w-full text-sm text-left">
                            <thead className="bg-gray-50 text-gray-600 uppercase text-xs">
                                <tr>
                                    <th className="px-4 py-3">Task</th>
                                    <th className="px-4 py-3">Frequency</th>
                                    <th className="px-4 py-3">Last Run</th>
                                    <th className="px-4 py-3">Status</th>
                                    <th className="px-4 py-3">Active</th>
                                    <th className="px-4 py-3 text-right">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tasks.map((task) => (
                                    <tr
                                        key={task.id}
                                        className="border-t hover:bg-gray-50 transition"
                                    >
                                        <td className="px-4 py-3 font-medium text-gray-800">
                                            {task.name}
                                        </td>
                                        <td className="px-4 py-3 capitalize">
                                            {task.frequency}
                                        </td>
                                        <td className="px-4 py-3 text-gray-600">
                                            {task.last_run_at
                                                ? new Date(task.last_run_at).toLocaleString()
                                                : "—"}
                                        </td>
                                        <td className="px-4 py-3">
                                            <CronStatusBadge
                                                status={task.last_status}
                                                isRunning={task.is_running}
                                            />
                                        </td>
                                        <td className="px-4 py-3">
                                            <CronToggleSwitch
                                                checked={task.is_active}
                                                onChange={() => handleToggle(task.id)}
                                                disabled={actionLoading === task.id}
                                            />
                                            {/* <label className="inline-flex items-center cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    checked={task.is_active}
                                                    onChange={() => handleToggle(task.id)}
                                                    className="sr-only peer"
                                                />
                                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer 
      peer-checked:bg-green-600 transition"></div>
                                            </label> */}
                                            {/* <button
                        onClick={() =>
                          handleToggle(task.id)
                        }
                        disabled={
                          actionLoading === task.id
                        }
                        className={`px-3 py-1 text-xs rounded-full ${
                          task.is_active
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        {task.is_active
                          ? "Active"
                          : "Disabled"}
                      </button> */}
                                        </td>
                                        <td className="px-4 py-3 text-right">
                                            <button
                                                onClick={() => openRunModal(task)}
                                                disabled={
                                                    actionLoading === task.id ||
                                                    task.is_running
                                                }
                                                className="px-4 py-2 text-xs font-medium bg-blue-600 hover:bg-blue-700 text-white rounded-lg disabled:opacity-50"
                                            >
                                                Run Now
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            <RunCronModal
                isOpen={runModalOpen}
                onClose={() => setRunModalOpen(false)}
                onRun={runWithWeek}
                templates={templates}
            />
        </div>
    );
};

export default CronManager;